import React from 'react';

import './errorBanner.scss';

/**
 * The ErrorDisplay component.
 *
 * @constructor
 */
export class ErrorDisplay extends React.Component {
  /**
   * @constructor
   * @param {{}} props
   * @param {{}} componentContext
   */
  constructor(props, componentContext) {
    super(props, componentContext);
  }

  /**
   * Renders the component.
   *
   * @returns {{}}
   */
  render() {
    return (
      <div className="error-banner callout alert">
        <h2>An Error Has Occurred</h2>
        <p>
          <span className="inline-text">Please contact WeGoLook at</span>
          <span className="inline-text"><a href="mailto:support@wegolook.com">WeGoLook Support</a></span>
          <span className="inline-text">or call +1 (855) 947-1788.</span>
        </p>
      </div>
    );
  }
}

ErrorDisplay.propTypes = {};

export default ErrorDisplay;



// WEBPACK FOOTER //
// ./src/components/common/errorBanner/ErrorBanner.js